<template>
  <a-row>
    <a-col :span="6">
      <a-form-item
        :labelCol="{ xs: { span: 24 }, sm: { span: 8 } }"
        :wrapperCol="{ xs: { span: 24 }, sm: { span: 15 } }"
        label="产品名称"
      >
        <a-select
          :allowClear="true"
          placeholder="请选择产品名称"
          showSearch
          optionFilterProp="children"
          v-decorator="[
            `productId[${item}]`,
            {
              initialValue: arr[item] ? arr[item].productId : undefined,
              rules: [{ required: true, message: '请选择产品' }],
            },
          ]"
          @change="chanegProduct"
          :disabled="!isEdit"
        >
          <a-select-option
            v-for="(option, index) in ProductNameList"
            :key="index"
            :value="option.id"
          >
            {{ option.productName }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-col>
    <a-col :span="6">
      <a-form-item
        :labelCol="{ xs: { span: 24 }, sm: { span: 8 } }"
        :wrapperCol="{ xs: { span: 24 }, sm: { span: 15 } }"
        label="产品总价"
      >
        <a-input
          placeholder="请输入产品总价"
          id="ArrNameNum"
          autocomplete="off"
          :allowClear="true"
          v-decorator="[
            `productPrice[${item}]`,
            {
              initialValue: arr[item] ? arr[item].productPrice : undefined,
              rules: [{ required: true, message: '请输入产品总价！' }],
            },
          ]"
          :disabled="!isEdit"
        />
      </a-form-item>
    </a-col>
    <a-col :span="10">
      <a-form-item
        :labelCol="{ xs: { span: 24 }, sm: { span: 4 } }"
        :wrapperCol="{ xs: { span: 24 }, sm: { span: 19 } }"
        label="功能模块"
      >
        <a-select
          :allowClear="true"
          placeholder="请选择功能模块"
          mode="multiple"
          showSearch
          optionFilterProp="children"
          @change="changeModule"
          v-decorator="[
            `modelId[${item}]`,
            {
              initialValue: arr[item] ? handleArr(arr[item].modules) : undefined,
              rules: [{ required: true, message: '请选择功能模块' }],
            },
          ]"
          :disabled="!isEdit"
        >
        <!-- initialValue: arr[item] ? arr[item].modules : undefined, -->
          <a-select-option
            v-for="(option, index) in ProductInfo.productModules"
            :key="index"
            :value="option.id"
          >
            {{ option.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-col>
    <a-col :span="2">
      <a-form-item>
        <a-button @click="removeRow(item)" :disabled="!isEdit">删除</a-button>
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
import { getProductInfo } from '@/api/product'
export default {
  props: {
    item: { type: Number },
    form: [Object],
    arr: {
      type: Array,
      default: function () {
        return []
      },
    },
    ProductNameList: {
      type: Array,
      default: function () {
        return []
      },
    },
    isAdd:{
        type:Boolean,
        default:true
    },
    type:[String]
  },
  computed:{
    isEdit(){
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  data() {
    return {
      model: {},
      ProductInfo: {},
    }
  },
  created(){
      if(this.type === this.$sysInfo.MODAL_MODIFY && !this.isAdd){
        const id = this.arr[this.item].productId
        getProductInfo({ id: id }).then((res) => {
            if (res.status === 0) {
            this.ProductInfo = res.data
            }
        })
      }
  },
  methods: {
    getData (name) {
      return this.model[name]
    },
    setData (name, data) {
      this.$set(this.model, name, data)
    },
    chanegProduct (value) {
      delete this.model.productName
      if (value) {
        const product = this.ProductNameList.filter(item => item.id === value)[0]
        //清空功能模块关联项!
        this.$set(this.model, 'productName', product.productName)
        console.log(this.form.getFieldValue('modelId'))
        let modelIdArr = this.form.getFieldValue('modelId')
        modelIdArr[this.item] = []
        console.log('前',this.form.getFieldValue('modelId'));
        this.form.setFieldsValue({
          modelId:modelIdArr
        })
        console.log('后',this.form.getFieldValue('modelId'));
        getProductInfo({ id: value }).then((res) => {
          if (res.status === 0) {
            this.ProductInfo = res.data
          }
        })
      }
    },
    changeModule (value) {
      delete this.model.modules
      if (value) {
        let arr = []
        value.map((val => {
          const modules = this.ProductInfo.productModules.filter(item => item.id === val)[0]
          const obj = {
            saleProductId:modules.productId,
            moduleId:modules.id,
            moduleName:modules.name
          }
          arr.push(obj)
        }))
        this.$set(this.model, 'modules', arr)
        console.log('排查model',arr);
      }
    },
    removeRow(item) {
      this.$emit('removeRow', item)
    },
    handleArr(value){
        const arr = []
        value.forEach((item,i)=>{
            if(item.moduleId){
                arr.push(item.moduleId)
            }
        })
        return arr
    },
    //删除最后一个项，清空表单
    clear(){
      let productIdArr = this.form.getFieldValue('productId')
      productIdArr[this.item] = ''
      let productPriceArr = this.form.getFieldValue('productPrice')
      productPriceArr[this.item] = ''
      let modelIdArr = this.form.getFieldValue('modelId')
      modelIdArr[this.item] = []
      this.form.setFieldsValue({
        productId:productIdArr,
        productPrice:productPriceArr,
        modelId:modelIdArr
      })
    },
    //select判断是否change
    changeProductName(){
      this.$emit('changeProductName',true)
    }
  },
}
</script>